import styled from 'styled-components';

interface SizeRange {
  max?: string;
  min?: string;
}

interface FjTextAreaProps {
  height?: string;
  width?: string;
  heightRange?: SizeRange;
  widthRange?: SizeRange;
  borderColor?: string;
  resize?: string;
  fontSize?: string;
}

const FjTextArea = styled.textarea.attrs<FjTextAreaProps>((props) => ({
  height: props.height || 'auto',
  width: props.width || 'auto',
  heightRange: props.heightRange || {},
  widthRange: props.widthRange || {},
  borderColor: props.borderColor || '#156777',
  resize: props.resize || 'both',
  fontSize: props.fontSize || '1em',
}))`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  max-height: ${({ heightRange }) => heightRange!.max || 'unset'};
  min-height: ${({ heightRange }) => heightRange!.min || 'unset'};
  max-width: ${({ widthRange }) => widthRange!.max || 'unset'};
  min-width: ${({ widthRange }) => widthRange!.min || 'unset'};
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 0;
  margin: 10px 0;
  resize: ${({ resize }) => resize};
  font-size: ${({ fontSize }) => fontSize};
`;

export default FjTextArea;
